import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import AppOverlaysComponent from "../components/elements/Overlays/AppOverlays.component";
import Search from "../components/search/search";
import { setCurrentFeature } from "../reduxStore/actions/main";
import { pageNames } from "../reduxStore/reducers/main";
import { terminalDisplayDownPixels } from "./app.sideEffects/useURLParams.sideEffects";
import style from "./terminalSide.module.scss";

function DualScreen(props) {
  const [searchActions, setSearchActions] = useState({});
  const [disabled, setDisabled] = useState(false);

  const history = useHistory();
  const handleSearchActions = () => {
    if (props.currentAppOverlay && props.currentAppOverlay.name) {
      setSearchActions({
        mustHaveLocation: props.currentAppOverlay.mustHaveLocation,
        onPOIClicked: props.currentAppOverlay.onPOIClicked,
        canSetCurrentPosition: false,
        canSetPositionOnMap: props.currentAppOverlay.canSetPositionOnMap,
        onSpecialLocationClicked:
          props.currentAppOverlay.onSpecialLocationClicked,
      });
    } else {
      // Wenn kein SearchOverlay vorhanden ist -> Stanni parameter übergeben
      setSearchActions({
        onPOIClicked: props.setCurrentFeature,
      });
    }
  };
  const handleWindowDisabling = () => {
    if (
      history.location.pathname === `/${pageNames.map}/${pageNames.navigation}/`
    ) {
      setDisabled(true);
    }

    return () => {
      setDisabled(false);
    };
  };

  useEffect(handleWindowDisabling, [history?.location.pathname]);

  useEffect(handleSearchActions, [props.currentAppOverlay]);

  if (props.serverDataLoaded) {
    return (
      <div
        style={{
          width: props.width,
          minWidth: props.width,
          maxWidth: props.width,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          paddingTop: props.displayDownMode ? terminalDisplayDownPixels : 0,
          transition: "1s",
        }}
        className="dualScreen"
      >
        <Search
          mustHaveLocation={searchActions.mustHaveLocation}
          onPOIClicked={searchActions.onPOIClicked}
          canSetCurrentPosition={searchActions.canSetCurrentPosition}
          canSetPositionOnMap={searchActions.canSetPositionOnMap}
          onSpecialLocationClicked={searchActions.onSpecialLocationClicked}
        />
        <AppOverlaysComponent />
        <DisabledOverlay value={disabled} />
      </div>
    );
  } else return null;
}

const DisabledOverlay = ({ value = false }) => {
  if (value) {
    return <div className={`${style.disabledContainer} pointer-event-on`} />;
  } else return null;
};

const mapDispatchToProps = (dispatch) => ({
  setCurrentFeature: (feature) => dispatch(setCurrentFeature(feature)),
});
const mapStateToProps = (state) => ({
  serverDataLoaded: state.main.serverDataLoaded,
  currentAppOverlay: state.main.currentAppOverlay,
  displayDownMode: state.main.displayDownMode,
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DualScreen)
);
